module.exports = __webpack_public_path__ + "static/img/lm35l-1.2f03ecc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/lm35l-1.svg
// module id = Ty5K
// module chunks = 0